import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		iconRoot: {
			marginRight: theme.spacing(8),
		},
		featuredMediaContainer: {
			display: 'flex',
			flexDirection: 'column',
			position: 'relative',
			minHeight: 'fit-content',
			border: `1px solid ${theme.palette.grey[200]}`,
			borderRadius: theme.spacing(1),
			// overflow: 'hidden',
			marginTop: theme.spacing(1),
		},
		deleteIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		deleteRootElement: {
			position: 'absolute',
			top: 0,
			right: 0,
		},
		player: {
			width: 'unset !important',
			'& iframe': {
				width: '100%',
				height: '100%',
			},
		},
		uploadMediaButtons: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-around',
		},
		uploadMediaErrorMsg: {
			padding: '10px 0px 10px 20px',
			color: theme.palette.secondary.main,
		},
	})
